import compose from 'recompose/compose';

import optionCallback from "../optionCallback";
import Base from './Base';
import Square from './Square';
import Circle from './Circle';
import RSquare from './RSquare';
import CSquare from './CSquare';
import { rotate } from "../../nodevn/ultil";
import React from "react";
import QRPointType from "../../qrcode/QRPointType";


function render({ source, transform, type }: any){
	let { color, data, transform : trans, size }: any = source || {};
	const attr = ({ fill: color })

	if(type === QRPointType.$ALIGN_OTHER){
		size = 100;
	}

	size = size || 125;

	const $pos  = (100 - size) / 2;
	const $scale = (size / 100);
	const $g_attr = { transform : ($pos || $scale) ? `translate(${$pos}, ${$pos}) scale(${$scale})` : "", };
	return rotate(<g {...$g_attr}>{data}</g>, trans, transform, attr)
}

const options = ({ render })

export default compose(
	optionCallback('ebg', 'ebg0', Base, options),
	optionCallback('ebg', 'ebg1', Square, options),
	optionCallback('ebg', 'ebg2', Circle, options),
	optionCallback('ebg', 'ebg3', RSquare, options),
	optionCallback('ebg', 'ebg4', CSquare, options),
	optionCallback('ebg', 'square', Square, options),
	optionCallback('ebg', 'circle', Circle, options),
	optionCallback('ebg', 'r-square', RSquare, options),
	optionCallback('ebg', 'c-square', CSquare, options),
	optionCallback('ebg', 'default', Base, options) // default phải luôn ở cuối
)